import { Grid, Typography } from "@mui/material";
import { options } from "../../../../components/contractListItem";
import { LOCALIZE_DATE, ROUTES } from "../../../../setup/constants";
import { CONTRACT_DETAILS, NUMBER, PARENT_NUMBER } from "../../constants";
import { IContractProps } from "../../models";
import { ContractDescription, ContractSubTitle } from "../../titles";

import styles from "./styles.module.css";
import { EContractType } from "../../../../setup/api/services/contract/models";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

export const MainDetailsHeading = ({ contract }: IContractProps) => {
  const navigate = useNavigate();

  const onLinkClick = () => {
    navigate(`${ROUTES.CONTRACT}${contract?.parentId}`);
  };

  return (
    <Grid item xs={12} sm container>
      <Grid item xs container direction="column" spacing={2}>
        <Grid item xs>
          <div className={styles.text_wrapper}>
            <Typography variant={"h1"}>
              {contract?.itemDetail?.title}
            </Typography>
            <p className={styles.contract_id}>
              {`${NUMBER}: ${contract?.shortId}#`}{" "}
              <span className={styles.tag}>
                {new Date(contract.createdAt).toLocaleDateString(
                  LOCALIZE_DATE,
                  options
                )}
              </span>
            </p>
            {contract?.type === EContractType.MILESTONE_CONTRACT && (
              <p className={classNames(styles.contract_id)}>
                {`${PARENT_NUMBER}: `}
                <span className={styles.link} onClick={onLinkClick}>
                  {contract?.parentId}#
                </span>
              </p>
            )}
          </div>
          {contract?.itemDetail?.description && (
            <div className={styles.text_wrapper}>
              <ContractSubTitle text={CONTRACT_DETAILS} />
              <ContractDescription text={contract?.itemDetail?.description} />
            </div>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
